
import React, { Suspense, lazy } from 'react';
import { CONFIG } from './config';

// 全域狀態 Provider 保持在頂層
import { ProductProvider } from './context/ProductContext';
import { CartProvider } from './context/CartContext';
import { BlogProvider } from './context/BlogContext';
import { NewsProvider } from './context/NewsContext';
import { OrderProvider } from './context/OrderContext';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import ChatWidget from './components/ChatWidget';

// 關鍵：使用 lazy loading 分離代碼塊
const PublicApp = lazy(() => import('./PublicApp'));
const AdminApp = lazy(() => import('./AdminApp'));

const AppContent: React.FC = () => {
  const { lang } = useLanguage();
  const isAdmin = CONFIG.isAdminMode;

  return (
    <div key={lang} className="min-h-screen relative">
      {/* 頁面內容容器，移除全域動畫以避免 CSS Transform 導致的 fixed 定位失效問題 */}
      <div className="min-h-screen">
        <Suspense fallback={
          <div className="min-h-screen bg-natuvia-beige flex flex-col items-center justify-center">
            <div className="animate-pulse flex flex-col items-center">
              <span className="text-natuvia-brown font-bold text-2xl tracking-widest uppercase mb-2">
                Natuvía
              </span>
              <div className="w-12 h-0.5 bg-natuvia-brown/20 rounded-full overflow-hidden">
                <div className="h-full bg-natuvia-brown animate-[loading_1.5s_infinite]"></div>
              </div>
            </div>
          </div>
        }>
          {isAdmin ? <AdminApp /> : <PublicApp />}
        </Suspense>
      </div>

      {/* ChatWidget 放在動畫 div 之外，確保固定定位相對於 Viewport */}
      <ChatWidget />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AuthProvider>
        <UserProvider>
          <ProductProvider>
            <CartProvider>
              <BlogProvider>
                <NewsProvider>
                  <OrderProvider>
                    <AppContent />
                  </OrderProvider>
                </NewsProvider>
              </BlogProvider>
            </CartProvider>
          </ProductProvider>
        </UserProvider>
      </AuthProvider>
    </LanguageProvider>
  );
};

export default App;
